import { WarningAmber } from "@mui/icons-material";
import { Alert } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

export const ReportWarningAlert = withDefaultProps(Alert, { icon: <WarningAmber />, severity: "warning" });
